import ContactForm from './ContactForm';

export default function Footer() {
  return (
    <>
      {/* Footer */}
      <footer className="bg-gray-50 text-black py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            {/* Left Side - Brand */}
            <div>
              <span className="text-4xl md:text-5xl font-bold text-black tracking-tight">
                Pragmatic AI
              </span>
            </div>

            {/* Right Side - Contact Info */}
            <div className="grid md:grid-cols-2 gap-10">
              <div>
                <div className="flex items-center space-x-3 mb-3">
                  <i className="ri-map-pin-line text-emerald-500"></i>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  2nd Floor, #198, CMH Road<br />
                  Indiranagar, Bengaluru – 560038<br />
                  India
                </p>
              </div>
              <div>
                <div className="flex items-center space-x-3 mb-3">
                  <i className="ri-mail-line text-emerald-500"></i>
                </div>
                <a href="mailto:support@pragmaticsystems.ai" className="text-gray-700 hover:text-emerald-600 transition-colors duration-200">
                  support@pragmaticsystems.ai
                </a>
              </div>
            </div>
          </div>

          <div className="mt-16 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">© 2026 Pragmatic AI. All rights reserved.</p>
            <div className="flex items-center space-x-6">
              <a href="/pricing" className="text-gray-500 hover:text-black text-sm transition-colors duration-200">Pricing</a>
              <a href="/faq" className="text-gray-500 hover:text-black text-sm transition-colors duration-200">FAQs</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
